import { useThemeStore } from "@stores/theme.store";
import { useEffect, useRef, useState } from "react";
import { MdKeyboardArrowRight } from "react-icons/md";
import { ActiveElementType } from "@services/dtos/general.dto";
import { Select } from "antd";
import { useQuery } from "@tanstack/react-query";
import { SchoolService } from "@services/school.service";
import { HomeService } from "@services/home.service";
import { Spiner } from "@components/loaders/spiner";
import { formatValue, toRp } from "@utils/helper";
import moment from "moment";

export const PocketInfo = () => {
  const { setHeader, setAppBar } = useThemeStore((state) => state);
  const contentRef = useRef<(HTMLDivElement | null)[]>([]);
  const [activeCollapse, setActiveCollapse] = useState<ActiveElementType>(
    {} as ActiveElementType
  );
  const [limit, setLimit] = useState("5");

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";

  const { data: dataSaldoUangSaku, isPending: isPendingUangSaku } = useQuery({
    queryKey: [HomeService.queries.GET_BILLS_AND_BALANCES, nis],
    queryFn: () => HomeService.billsAndBalances({ nis }),
  });

  const { data: laporanUangSaku, isPending: isPendingLaporanUangSaku } =
    useQuery({
      queryKey: [HomeService.queries.GET_DATA_REPORT_BALANCES, nis, limit],
      queryFn: () => HomeService.reportBalances({ nis, limit }),
    });

  const totalMasuk = (laporanUangSaku?.data ?? [])
    .sort((a, b) => moment(b.tanggal).diff(moment(a.tanggal)))
    .filter((i) => i.tipe === "masuk")
    .slice(0, parseInt(limit))
    .map((i) => parseFloat(i.uangsakumasuk?.replaceAll(",", "") ?? 0))
    .reduce((a, b) => a + b, 0);

  const totalKeluar = (laporanUangSaku?.data ?? [])
    .sort((a, b) => moment(b.tanggal).diff(moment(a.tanggal)))
    .filter((i) => i.tipe === "keluar")
    .slice(0, parseInt(limit))
    .map((i) => parseFloat(i.uangkeluar?.replaceAll(",", "") ?? 0))
    .reduce((a, b) => a + b, 0);

  const collapsibleView = (index: number) => {
    setActiveCollapse({
      active: index === activeCollapse.index ? !activeCollapse.active : true,
      index,
    });
  };

  const collapsibleContent = [
    {
      header: (
        <>
          <div className="tw-w-full">
            <div className="tw-px-2 tw-flex tw-justify-between tw-items-center tw-font-semibold">
              <div className="tw-text-xs tw-font-medium tw-text-other-600">
                Laporan
              </div>
              {/* <div className="tw-text-xs tw-font-medium tw-text-other-600">
                Total
              </div> */}
            </div>
            <div className="tw-px-2 tw-flex tw-justify-between tw-items-center tw-font-semibold">
              <div className="tw-text-sm">Uang Masuk</div>
              {/* <div className="tw-w-1/2 tw-text-end">
                <div className="tw-text-sm">{toRp(totalMasuk)}</div>
              </div> */}
            </div>
          </div>
        </>
      ),
      children: (
        <>
          <div className="tw-px-4 tw-py-2 tw-text-[#000] tw-bg-[#f9f9f9] tw-border-b-2">
            {(laporanUangSaku?.data ?? [])
              .sort((a, b) => moment(b.tanggal).diff(moment(a.tanggal)))
              .filter((i) => i.tipe === "masuk")
              .slice(0, parseInt(limit))
              .map((item, idx) => (
                <div className="tw-py-2" key={idx}>
                  <div className="tw-px-2 tw-flex tw-justify-between tw-items-center tw-font-semibold">
                    <div className="tw-text-xs tw-font-medium tw-text-other-600">
                      {moment(item.tanggal ?? Date.now()).format(
                        "DD MMMM YYYY"
                      )}
                    </div>
                  </div>
                  <div className="tw-px-2 tw-flex tw-justify-between tw-items-start tw-font-semibold">
                    <div className="tw-text-sm">{item.catatan}</div>
                    <div className="tw-w-1/2 tw-text-end">
                      <div className="tw-text-sm">
                        {toRp(
                          parseFloat(
                            ((item.uangsakumasuk ?? "") + "").replaceAll(
                              ",",
                              ""
                            ) ?? 0
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </>
      ),
    },
    {
      header: (
        <>
          <div className="tw-w-full">
            <div className="tw-px-2 tw-flex tw-justify-between tw-items-center tw-font-semibold">
              <div className="tw-text-xs tw-font-medium tw-text-other-600">
                Laporan
              </div>
              {/* <div className="tw-text-xs tw-font-medium tw-text-other-600">
                Total
              </div> */}
            </div>
            <div className="tw-px-2 tw-flex tw-justify-between tw-items-center tw-font-semibold">
              <div className="tw-text-sm">Uang Keluar</div>
              {/* <div className="tw-w-1/2 tw-text-end">
                <div className="tw-text-sm">{toRp(totalKeluar)}</div>
              </div> */}
            </div>
          </div>
        </>
      ),
      children: (
        <>
          <div className="tw-px-4 tw-py-2 tw-text-[#000] tw-bg-[#f9f9f9] tw-border-b-2">
            {(laporanUangSaku?.data ?? [])
              .sort((a, b) => moment(b.tanggal).diff(moment(a.tanggal)))
              .filter((i) => i.tipe === "keluar")
              .slice(0, parseInt(limit))
              .map((item, idx) => (
                <div className="tw-py-2" key={idx}>
                  <div className="tw-px-2 tw-flex tw-justify-between tw-items-center tw-font-semibold">
                    <div className="tw-text-xs tw-font-medium tw-text-other-600">
                      {moment(item.tanggal ?? Date.now()).format(
                        "DD MMMM YYYY"
                      )}
                    </div>
                  </div>
                  <div className="tw-px-2 tw-flex tw-justify-between tw-items-start tw-font-semibold">
                    <div className="tw-text-sm tw-w-1/2">{item.catatan}</div>
                    <div className="tw-w-1/2 tw-text-end">
                      <div className="tw-text-sm">
                        {toRp(
                          parseFloat(
                            ((item.uangkeluar ?? "") + "").replaceAll(
                              ",",
                              ""
                            ) ?? 0
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </>
      ),
    },
  ];

  useEffect(() => {
    setAppBar({ title: "Uang Saku", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Uang Saku",
    });
  }, [setHeader, setAppBar]);
  return (
    <>
      <div className="bg-semi-circle"></div>
      <div className="tw-px-4 tw-pb-20">
        {/* pocket highlight */}
        <div className="tw-mt-3">
          <div className="tw-px-4 tw-pt-0 tw-pb-5 tw-text-white">
            <div className="tw-flex tw-justify-between">
              <div className="tw-content-center tw-text-center tw-px-1"></div>
              <div className="tw-text-center">
                <div className="tw-mb-2 tw-text-4xl tw-font-bold">
                  {isPendingUangSaku ? (
                    <div className="tw-py-2 tw-text-center">
                      <Spiner className="" />
                    </div>
                  ) : (
                    toRp(dataSaldoUangSaku?.data?.saldo ?? 0)
                  )}
                </div>
                <div className="tw-text-xs">total uang tersisa</div>
              </div>
              <div className="tw-content-center tw-text-center tw-px-1"></div>
            </div>
          </div>
        </div>
        {/* end of pocket highlight */}

        {/* finance report */}
        <div className="tw-bg-other-100 tw-rounded-lg card-body">
          <div className="tw-text-xs tw-mb-1">Filter Data</div>
          <Select
            className="tw-border-other-0 tw-text-base"
            placeholder="Pilih Jumlah Ditampilkan"
            defaultValue={limit}
            style={{ width: "100%" }}
            allowClear
            onChange={(e) => setLimit(e)}
            options={[
              { value: "5", label: "5" },
              { value: "10", label: "10" },
              { value: "25", label: "25" },
            ]}
          ></Select>
          <p className="tw-mt-3 tw-text-sm">
            Data yang ditampilkan {limit} data terakhir
          </p>
        </div>
        <div className="tw-mt-2 tw-rounded-lg card">
          {isPendingLaporanUangSaku ? (
            <div className="tw-py-2 tw-text-center">
              <Spiner className="" />
            </div>
          ) : (
            <>
              {collapsibleContent.map((view, index) => (
                <div key={index}>
                  <div
                    className={`tw-py-3 tw-px-2.5 tw-border-solid tw-border-x-0 tw-border-b-0 tw-border-t-1 tw-border-t-other-300 collapse-header tw-rounded-lg`}
                    onClick={() => {
                      collapsibleView(index + 1);
                    }}
                  >
                    <div className="tw-flex tw-justify-center tw-items-center collapse-header-box">
                      <MdKeyboardArrowRight
                        className={`collapse-header-icon ${
                          activeCollapse.active &&
                          activeCollapse.index === index + 1
                            ? "rotating"
                            : ""
                        }`}
                        size={20}
                      />
                      {view.header}
                    </div>
                  </div>

                  <div
                    className={`tw-text-sm tw-text-other-600 tw-bg-other-100 tw-border-b tw-border-other-300 collapse-content collapse-content-${index}`}
                    ref={(el) => (contentRef.current[index] = el)}
                    style={{
                      maxHeight:
                        activeCollapse.active &&
                        activeCollapse.index === index + 1
                          ? //`${contentRef.current?.scrollHeight}px`
                            `${contentRef.current[index]?.scrollHeight ?? 0}px`
                          : // "max-content"
                            "0px",
                    }}
                  >
                    {view.children}
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
        {/* end of finance report */}
      </div>
    </>
  );
};
